<template>
    <grid
        ref="grid"
        :column-defs="columnDefs"
        :row-data="properties"
        :is-auto-height="false"
    ></grid>
</template>

<script>
import API from '../../api';
import {
    DOCUMENT_PROPERTIES_ENDPOINT,
    DOCUMENT_PROPERTY_BY_ID_ENDPOINT,
    DOCUMENT_REPORT_TEMPLATE_AGREEMENTS_ENDPOINT,
} from '../../endpoints';
import { escapeHTML } from '../../utils/strings';
import Grid from '../generic/grid/grid.vue';

const DEFAULT_AGREEMENT_NAME = 'Default';

export default {
    name: 'DocumentAgreements',
    components: {
        Grid,
    },
    computed: {
        agreementOptions() {
            return [
                { value: null, text: DEFAULT_AGREEMENT_NAME },
                ...this.agreements.map(agreement => ({
                    value: agreement.id,
                    text: agreement.report_name,
                }))
            ];
        },
    },
    data() {
        return {
            agreements: [],
            agreementsByID: {},
            properties: [],
            columnDefs: [
                {
                    field: 'id',
                    type: 'idColumn',
                    maxWidth: 110,
                    sort: 'asc',
                },
                {
                    field: 'name',
                    headerName: 'Property Name',
                },
                {
                    headerName: 'Rental Agreement',
                    cellEditor: 'selectCellEditor',
                    editable: true,
                    cellClass: 'text-primary lx-editable-cell',
                    cellEditorParams: ({ data }) => ({
                        options: this.agreementOptions
                    }),
                    valueGetter: ({ data }) => data.agreement_id,
                    getQuickFilterText: ({ data }) => this.getAgreementNameByID(data.agreement_id),
                    cellRenderer: ({ data }) => escapeHTML(this.getAgreementNameByID(data.agreement_id)),
                        valueSetter: async ({ node, data, newValue, oldValue }) => {
                            (async () => {
                                try {
                                    await API.patch(
                                        DOCUMENT_PROPERTY_BY_ID_ENDPOINT(data.id),
                                        {
                                            agreement_id: newValue,
                                        }
                                    );
                                } catch {
                                    this.errorToast({text: 'Could not save agreement.'})
                                    data.agreement_id = oldValue;
                                    node.setData(data)
                                }
                            })();
                            data.agreement_id = newValue;
                            return true;
                        },
                }
            ]
        }
    },
    mounted() {
        this.load();
    },
    methods: {
        async load() {
            this.$parent.$emit('busy', true);

            try {
                await Promise.all([
                    this.fetchAgreements(),
                    this.fetchProperties(),
                ]);
            } finally {
                this.$parent.$emit('busy', false);
            }
        },
        async fetchAgreements() {
            try {
                const response = await API.get(DOCUMENT_REPORT_TEMPLATE_AGREEMENTS_ENDPOINT());
                this.agreements = response.data;
                this.agreementsByID = response.data.reduce((agreementsByID, agreement) => ({
                    ...agreementsByID,
                    [agreement.id]: agreement,
                }), {});
            } catch {
                this.errorToast({text: 'Could not load agreements.'})
            }
        },
        async fetchProperties() {
            try {
                const response = await API.get(DOCUMENT_PROPERTIES_ENDPOINT());
                this.properties = response.data;
            } catch {
                this.errorToast({text: 'Could not load properties.'})
            }
        },
        getAgreementNameByID(id) {
            if (id && this.agreementsByID[id]) {
                return this.agreementsByID[id].report_name;
            }
            return DEFAULT_AGREEMENT_NAME;
        },
    }
}
</script>
